import './table_of_contents_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  get height () {
    return this.element.offsetHeight
  }
}
